import React, { Component } from "react";
import { connect } from "react-redux";

//import { generateText } from "@/jscript/openai.js";
import axios from "axios";

import "@/css/cart.css";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prompt: "",
      text: "",
      list: [],
    };
  }
  render() {
    const { myusername } = this.props;

    return (
      <div
        style={{
          color: this.state.color,
          fontSize: "25px",
          padding: "30px 10px",
        }}
      >
        <form onSubmit={this.handleSubmit}>
          <input
            placeholder="请输入你的问题"
            ref={(input) => {
              this.prompt = input;
            }}
            style={{ margin: "8px", width: "500px" }}
          />

          <button type="submit" style={{ width: "100px" }}>
            发出
          </button>
        </form>
        {this.state.list.length > 0 && (
          <div>
            {this.state.list.map((item, index) => {
              return (
                <div key={"img" + index}>
                  <img
                    src={item.url}
                    alt="generated"
                    style={{ width: "300px", height: "300px" }}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
  modelselect(e) {
    //  console.log(e.target.value);

    this.setState({
      selectedmodel: e.target.value,
    });
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    let prompt = this.prompt.value;

    //let str = `${process.env.REACT_APP_OPENAI_API_KEY}`;

    //  const prompt = "Hello, OpenAI!";
    console.log(prompt);

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
    };

    let posturl = "https://api.openai.com/v1/images/generations";

    /*   data = {
      prompt: prompt,
      model: model,
      max_tokens: 5,
    };
 */
    /* 
curl https://api.openai.com/v1/completions \
  -H "Content-Type: application/json" \
  -H "Authorization: Bearer $OPENAI_API_KEY" \
  -d '{
  "model": "text-davinci-003",
  "prompt": "I am a highly intelligent question answering bot. If you ask me a question that is rooted in truth, I will give you the answer. If you ask me a question that is nonsense, trickery, or has no clear answer, I will respond with \"Unknown\".\n\nQ: What is human life expectancy in the United States?\nA: Human life expectancy in the United States is 78 years.\n\nQ: Who was president of the United States in 1955?\nA: Dwight D. Eisenhower was president of the United States in 1955.\n\nQ: Which party did he belong to?\nA: He belonged to the Republican Party.\n\nQ: What is the square root of banana?\nA: Unknown\n\nQ: How does a telescope work?\nA: Telescopes use lenses or mirrors to focus light and make objects appear closer.\n\nQ: Where were the 1992 Olympics held?\nA: The 1992 Olympics were held in Barcelona, Spain.\n\nQ: How many squigs are in a bonk?\nA: Unknown\n\nQ: Where is the Valley of Kings?\nA:",
  "temperature": 0,
  "max_tokens": 100,
  "top_p": 1,
  "frequency_penalty": 0.0,
  "presence_penalty": 0.0,
  "stop": ["\n"]
}' */

    let data = {
      prompt: prompt,
      n: 4,
      size: "1024x1024",
    };
    axios
      .post(posturl, data, { headers: headers })
      .then((response) => {
        let result = response.data;
        console.log(result.data);
        this.setState({
          list: result.data,
        });
      })
      .catch((error) => {
        console.error(error);
      });
    // const generatedText = await generateText(prompt);

    // console.log(generatedText);
    //  setText(generatedText);
  };

  componentDidMount() {
    document.title = "Open Ai Image";
  }

  componentWillUnmount() {
    //   $("#bottomer").css("display", "block");
  }

  componentWillUpdate() {}
  componentDidUpdate() {}
}

export default connect(null, null)(Index);
